export default class numericValidator {
    constructor() {
    }

    validate(value, decimalSeparator) {
        // let thousandsSeparator = '.';
        // if(decimalSeparator === '.') {
        //     thousandsSeparator = ',';
        // }

        const regex = new RegExp(`^[0-9]+([${decimalSeparator}][0-9]{1,2})?$`);

        return !!(value.match(regex));
        // return (!isNaN(parseFloat(value)) && isFinite(value));
    }
}
